import * as React from "react";
import Button from "@mui/material/Button";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { MouseEventHandler } from "react";

export interface LoginButtonProps {
  onClick: MouseEventHandler;
}

const LoginButton = ({ onClick }: LoginButtonProps) => {
  return (
    <Button
      color="secondary"
      variant="contained"
      onClick={onClick}
      size="medium"
      startIcon={<AccountCircleIcon />}
    >
      Log In
    </Button>
  );
};

export default LoginButton;
